import { Fragment, useEffect, type ComponentType } from 'react';
import { SECTION_REGISTRY } from '@/lib/sections/registry';
import { DeferredSection } from './DeferredSection';
import type { SectionInstance } from '@/lib/sections/types';

function EagerSection({
  Component,
  config,
  onMounted,
}: {
  Component: ComponentType<any>;
  config: SectionInstance['config'];
  onMounted?: () => void;
}) {
  useEffect(() => {
    onMounted?.();
  }, [onMounted]);

  return <Component config={config} />;
}

/**
 * Generyczny renderer listy sekcji — nie wie nic o Home konkretnie. Kolejność
 * i widoczność sterowane przez `sections` (dziś src/data/homeSections.config.ts,
 * jutro odpowiedź CMS w tym samym kształcie). Sekcje mają wspólne białe tło
 * i nie są rozdzielane dekoracyjnymi falami.
 */
export function SectionRenderer({
  sections,
  onSectionMounted,
}: {
  sections: SectionInstance[];
  onSectionMounted?: () => void;
}) {
  return (
    <>
      {sections
        .filter(s => s.enabled)
        .sort((a, b) => a.order - b.order)
        .map(s => {
          const Component = SECTION_REGISTRY[s.type];
          const section = ['hero', 'mobileCategoryTiles', 'categoryNav', 'seoTextSection'].includes(s.type) ? (
            <EagerSection
              Component={Component}
              config={s.config}
              onMounted={onSectionMounted}
            />
          ) : (
            <DeferredSection
              Component={Component}
              config={s.config}
              placeholderHeight={s.placeholderHeight}
              onMounted={onSectionMounted}
            />
          );

          return (
            <Fragment key={s.id}>
              {s.wrapperClassName ? <div className={s.wrapperClassName}>{section}</div> : section}
            </Fragment>
          );
        })}
    </>
  );
}
